<template>

    <form @submit.prevent="handleSubmit"
        class="w-full lg:w-2/3 mx-auto h-full py-5 flex flex-col justify-start items-center space-y-10 px-2 lg:px-0">

        <!-- Title and Description -->
        <div class="w-full flex flex-col justify-start items-center space-y-2"
            :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">

            <div class="text-sm lg:text-base w-full">
                {{ $t('edit.intro') }}
            </div>
        </div>

        <!-- Personal Info -->
        <div class="w-full flex flex-col justify-center items-center space-y-2 lg:space-y-5">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-5 w-full">
                <!-- Last Name -->
                <div>
                    <input type="text" v-model="form.lastName"
                        :class="(input_errors.lastName.error ? 'border border-red-400 ' : 'border border-gray-300 ') +
                            'focus:border-gray-600 transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'"
                        placeholder="Nom de famille *" />
                    <p v-if="input_errors.lastName.error" class="text-sm text-red-500 mt-1">
                        {{ $t('edit.errors.last_name') }}
                    </p>
                </div>

                <!-- First Name -->
                <div>
                    <input type="text" v-model="form.firstName"
                        :class="(input_errors.firstName.error ? 'border border-red-400 ' : 'border border-gray-300 ') +
                            'focus:border-gray-600 transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'"
                        :placeholder="$t('edit.first_name')" />
                    <p v-if="input_errors.firstName.error" class="text-sm text-red-500 mt-1">
                        {{ $t('edit.errors.first_name') }}
                    </p>
                </div>

                <!-- Phone -->
                <div>
                    <input type="text" v-model="form.phone"
                        :class="(input_errors.phone.error ? 'border border-red-400 ' : 'border border-gray-300 ') +
                            'focus:border-gray-600 transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'"
                        :placeholder="$t('edit.phone')" />
                    <p v-if="input_errors.phone.error" class="text-sm text-red-500 mt-1">
                        {{ $t('edit.errors.phone') }}
                    </p>
                </div>

                <!-- Function -->
                <div>
                    <select name="functions" id="functions" v-model="form.function"
                        :class="(input_errors.function.error ? 'border border-red-400 ' : 'border border-gray-300 ') +
                            'focus:border-gray-600 transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'">
                        <option value="0">{{ $t('edit.function') }}</option>
                        <option :value="f" v-for="(f, i) in functions" :key="i">
                            {{ $t('function.' + f) }}
                        </option>
                    </select>
                    <p v-if="input_errors.function.error" class="text-sm text-red-500 mt-1">
                        {{ $t('edit.errors.function') }}
                    </p>
                </div>
                <!-- <div>
                    <input type="text" v-model="form.function"
                        :class="(input_errors.function.error ? 'border border-red-400 ' : 'border border-gray-300 ') +
                            'focus:border-gray-600 transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'"
                        :placeholder="$t('edit.function')" />
                    <p v-if="input_errors.function.error" class="text-sm text-red-500 mt-1">
                        {{ $t('edit.errors.function') }}
                    </p>
                </div> -->
            </div>

            <!-- Company and Hectares -->
            <div class="flex  items-start w-full space-x-2 lg:space-x-5">
                <div v-if="['revendeur', 'distributeur'].includes(form.function)" class="w-3/5 lg:w-2/3">
                    <input type="text" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" v-model="form.company"
                        class="focus:border-gray-600 transition duration-200 outline-none w-full border border-gray-300 rounded px-3 py-2 text-sm lg:text-base"
                        :placeholder="$t('placeholders.company')" />

                    <p v-if="input_errors.company.error" class="text-sm text-red-500 mt-1">
                        {{ $t('errors.company') }}
                    </p>
                </div>
                <div
                    :class="['revendeur', 'distributeur'].includes(form.function) ? 'w-2/5 lg:w-1/3' : 'w-full lg:w-1/2 lg:pr-2.5'">
                    <input type="text" v-model="form.hectares"
                        class="focus:border-gray-600 transition duration-200 outline-none w-full border border-gray-300 rounded px-3 py-2 text-sm lg:text-base"
                        :placeholder="$t('placeholders.hectares')" />
                    <div class="text-xs text-gray-600 mt-1">{{ $t('labels.hectares_note') }}</div>
                </div>
            </div>
        </div>


        <div class="w-full">
            <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" :class="(input_errors.cultures.error ? 'text-red-400 underline ' : '') +
                'text-sm lg:text-lg font-medium  lg:w-full'">
                {{ $t('edit.cultures_label') }}
            </div>
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-5 mt-5">
                <div class="space-x-2 flex items-baseline justify-start" v-for="(culture, i) in cultures" :key="i">
                    <input type="checkbox" :id="culture.id" v-model="culture.checked" class="text-primary" />
                    <label class="text-gray-600 font-medium" :for="culture.id">{{ $t(culture.label) }}</label>
                </div>
            </div>
            <p v-if="input_errors.cultures.error" class="text-sm text-red-500 mt-1">
                {{ $t('edit.errors.cultures') }}
            </p>
        </div>


        <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-5 w-full">
            <!-- Wilaya -->
            <div>
                <v-select v-model="form.wilaya" :options="AllWilayas" :reduce="w => w.name"
                    :label="$i18n.locale === 'ar' ? 'name_ar' : 'name'" :placeholder="$t('edit.select_wilaya')"
                    :class="input_errors.wilaya.error ? 'border border-red-400' : ''" @update:modelValue="getCommunes">
                    <template #no-options>
                        <span class="text-gray-500">{{ $t('placeholders.noResultsFound') }}</span>
                    </template>

                </v-select>
                <p v-if="input_errors.wilaya.error" class="text-sm text-red-500 mt-1">
                    {{ $t('edit.errors.wilaya') }}
                </p>
            </div>

            <!-- Commune -->
            <div>
                <v-select v-model="form.commune" :options="communes" :reduce="c => c.commune_name_ascii"
                    :label="$i18n.locale === 'ar' ? 'commune_name' : 'commune_name_ascii'"
                    :placeholder="$t('edit.select_commune')"
                    :class="input_errors.commune.error ? 'border border-red-400' : ''">

                    <template #no-options>
                        <span class="text-gray-500">{{ $t('placeholders.noResultsFound') }}</span>
                    </template>

                </v-select>
                <p v-if="input_errors.commune.error" class="text-sm text-red-500 mt-1">
                    {{ $t('edit.errors.commune') }}
                </p>
            </div>
        </div>


        <div class="flex flex-col lg:flex-row justify-between items-center w-full space-y-3 lg:space-y-0">

            <!-- On mobile: first | On large: second -->
            <input type="submit"
                class="bg-primary w-full lg:w-1/6 text-white text-center rounded py-2 order-1 lg:order-2"
                :value="$t('edit.confirm')" />

            <!-- On mobile: second | On large: first -->
            <div class="text-sm lg:text-base text-gray-600 order-2 lg:order-1">
                {{ $t('edit.done_editing') }}
                <span class="text-primary underline font-medium hover:cursor-pointer" @click="logout">
                    {{ $t('edit.logout') }}
                </span>
            </div>

        </div>
    </form>

</template>

<script setup>
import { onMounted, ref, defineEmits, watch } from 'vue';
import { wilayas as AllWilayas } from '@/data/wilayas';
import { communes as AllCommunes } from '@/data/communes';
import { cultures as allCultures } from '@/data/cultures';
import { functions } from '@/data/functions';
const cultures = ref([]);
const communes = ref([]);

import { requestSubscriptionEdit } from '@/api/subscription';
import { useSubscriberStore } from '@/stores/subscriber';
import { useAdminStore } from '@/stores/admin';

import vSelect from "vue3-select";
import "vue3-select/dist/vue3-select.css";


const subscriberStore = useSubscriberStore();
const adminStore = useAdminStore();

const form = ref({
    lastName: '',
    firstName: '',
    phone: '',
    function: '',
    company: '',
    hectares: '',
    type: '',
    wilaya: '',
    commune: '',
    cultures: [],
});
watch(
    () => form.value.phone,
    (newVal) => {
        form.value.phone = newVal.replace(/\D/g, "");
    }
);

const validatePhone = () => {
    const phone = form.value.phone;

    if (!/^(05|06|07)\d{8}$/.test(phone)) {
        input_errors.value.phone.error = true;

    } else {
        input_errors.value.phone.error = false;

    }
};

watch(() => form.value.phone, validatePhone);

watch(() => form.value.hectares,
    (newVal) => {
        form.value.hectares = newVal.replace(/\D/g, "");
    }
);


const input_errors = ref({
    lastName: { error: false },
    firstName: { error: false },
    phone: { error: false },
    company: { error: false },
    wilaya: { error: false },
    commune: { error: false },
    cultures: { error: false },
    function: { error: false },
    rules: { error: false }
})


onMounted(async () => {
    emit('toggleLoadingOn');


    if (subscriberStore.isFilled) {
        populateFormFromStore();
    } else if (localStorage.getItem('auth_token')) {
        const success = await subscriberStore.loadUserFromToken();
        if (success) {
            populateFormFromStore();
        } else {
            router.push('/login');
        }
    } else {
        router.push('/login');
    }
    emit('toggleLoadingOff');

});


const populateFormFromStore = () => {
    form.value = {
        lastName: subscriberStore.lastName || '',
        firstName: subscriberStore.firstName || '',
        phone: subscriberStore.phone || '',
        function: subscriberStore.function || '',
        company: subscriberStore.company || '',
        hectares: subscriberStore.hectares || '',
        type: subscriberStore.type || '',
        wilaya: subscriberStore.wilaya || '',
        commune: subscriberStore.commune || '',
        cultures: subscriberStore.cultures || [],
    };



    cultures.value = allCultures.map(c => ({
        ...c,
        checked: form.value.cultures.includes(c.id)
    }));

    let selectedWilaya = AllWilayas.find(w => w.name === form.value.wilaya);



    communes.value = selectedWilaya
        ? AllCommunes.filter(c => c.wilaya_code === selectedWilaya.id)
        : [];


};

const getCommunes = () => {


    if (form.value.wilaya === null) {
        form.value.commune = null;
        return
    }

    form.value.wilaya = getWilayaByName(form.value.wilaya);
    let wilayaCode = form.value.wilaya.id;
    form.value.wilaya = form.value.wilaya.name;
    communes.value = wilayaCode
        ? AllCommunes.filter(c => c.wilaya_code === wilayaCode)
        : []


    form.value.commune = null;
    input_errors.value.wilaya.error = false;
    input_errors.value.commune.error = false;
}


const getWilayaByName = (name) => {
    return AllWilayas.find(w => w.name === name);
}



import { useRouter } from 'vue-router';

const router = useRouter();


const emit = defineEmits([
    "toggleLoadingOn",
    "toggleLoadingOff",
    "toggleSuccessModal",
    "LoggingOut"
]);


const handleSubmit = async () => {
    form.value.cultures = cultures.value.filter(c => c.checked).map(c => c.id);
    emit('toggleLoadingOn');

    setTimeout(async () => {
        if (validateFields()) {
            emit('toggleLoadingOff');
            return;
        }
        try {
            if (!['revendeur', 'distributeur'].includes(form.value.function)) {
                form.value.company = null;
            }

            const response = await requestSubscriptionEdit(form.value);



            subscriberStore.setFormData({ user: form.value });

            if (response.data.otp_required) {
                router.push('/verify-edit');
            } else {
                emit('toggleSuccessModal');
            }
        } catch (error) {
            console.error(error);
            validateField(error.response.data.field, true, "• Numéro de téléphone invalide\n");
        } finally {
            emit('toggleLoadingOff');
        }
    }, 1000);

};

let hasError = false;
const validateFields = () => {
    hasError = false;



    validateField('lastName', !form.value.lastName);
    validateField('firstName', !form.value.firstName);
    validateField('phone', !form.value.phone || input_errors.value.phone.error);
    validateField('function', !form.value.function || form.value.function === 0);
    validateField('company', !form.value.company && ['revendeur', 'distributeur'].includes(form.value.function));
    validateField('wilaya', !form.value.wilaya || form.value.wilaya === 0);
    validateField('commune', !form.value.commune || form.value.commune === 0);
    validateField('cultures', form.value.cultures.length === 0);

    return hasError;
};

const validateField = (field, condition) => {

    if (condition) {
        input_errors.value[field].error = true;

        hasError = true;
    } else {
        input_errors.value[field].error = false;
    }
};



const logout = () => {

    localStorage.removeItem('auth_token');
    adminStore.$reset();
    subscriberStore.$reset();
    emit('LoggingOut');

};
</script>
